export enum BadgeStatus {
  Success = "success",
  Warning = "warning",
  Error = "error",
  Info = "info",
  Neutral = "neutral",
}
